import { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import {
  getIntegrations,
  integrationsLoadingSelector
} from "Reducers/integration";
import { useAppDispatch, useAppSelector } from "Store/hooks";

const useLoadIntegrations = (
  options?: Partial<{ defaultProjectId: string }>
) => {
  const loading = useAppSelector(integrationsLoadingSelector);
  const dispatch = useAppDispatch();
  const { projectId = options?.defaultProjectId ?? "" } = useDecodedParams<{
    projectId: string;
  }>();

  useEffect(() => {
    dispatch(getIntegrations({ projectId }));
  }, [dispatch, projectId]);

  return loading;
};

export default useLoadIntegrations;
